<div
  *ngIf="commissionTableObject"
  fxLayout="column"
  fxLayoutGap="15px"
  class="commission-table-details-view-container"
>

  <div
    fxLayout="row"
    fxLayoutGap="15px"
  >

    <button
      mat-stroked-button
      color="primary"
      (click)="modify()"
      [disabled]="
        !(userPermissions | async).settlement.write
      "
    >
      <mat-icon>create</mat-icon>
      <span> Edytuj</span>
    </button>
  </div>

  <div
    fxLayout="row"
    fxLayout.lt-lg="column"
    fxLayoutGap="15px"
  >
    <div fxFlex="50" fxFlex.lt-lg="100">
      <mat-card>
        <h3>Dane tabeli prowizyjnej</h3>
        <div
          fxLayout="row"
          fxLayoutGap="15px"
        >

          <app-detail
            fxFlex="70"
            header="Nazwa"
            [value]="commissionTableObject.name"
          ></app-detail>

          <app-detail
            fxFlex="30"
            header="Nazwa skrócona"
            [value]="commissionTableObject.shortName"
          ></app-detail>

        </div>
        <div
          fxLayout="row"
          fxLayoutGap="15px"
        >

          <app-detail
            fxFlex="50"
            header="Obowiązuje od"
            [value]="
          commissionTableObject.validFrom
            | date:'yyyy-MM-dd'
        "
          ></app-detail>

          <app-detail
            fxFlex="50"
            header="Obowiązuje do"
            [value]="
          commissionTableObject.validTo
            ? (commissionTableObject.validTo
                | date:'yyyy-MM-dd')
            : '-'
        "
          ></app-detail>

        </div>
        <div
          fxLayout="row"
          *ngIf="commissionTableObject.sourceTable"
        >

          <app-detail
            fxFlex="100"
            header="Tabela źródłowa"
            [value]="
          commissionTableObject.sourceTable.shortName
          + ' - '
          + commissionTableObject.sourceTable.name
        "
          ></app-detail>

        </div>
      </mat-card>
    </div>

    <div fxFlex="50" fxFlex.lt-lg="100">
      <mat-card>

        <h3>Przypisania</h3>

        <div
          *ngFor="
        let assignment
          of commissionTableObject.assignments
      "
          fxLayout="row"
          fxLayoutGap="15px"
        >

          <app-detail
            fxFlex="50"
            header="Firma"
            [value]="assignment.company.name"
          ></app-detail>

          <app-detail
            fxFlex="50"
            header="Rodzaj umowy Partnera"
            [value]="assignment.contractType.name"
          ></app-detail>

        </div>

      </mat-card>
    </div>

  </div>
</div>
